import { type SuretyAccountId } from "@inrev/common";
import { DecisioningDataProvider } from "./DecisioningDataContext";
import { DecisioningPanelBody } from "./DecisioningPanelBody";
import {
	DecisioningPanelProvider,
	type DecisioningSheet,
	type DecisioningTab,
} from "./DecisioningPanelContext";

export type DecisioningPanelProps = {
	accountId: SuretyAccountId;
	initialTab?: DecisioningTab;
	initialSheet?: DecisioningSheet | null;
	initialExpandedIds?: readonly string[];
};

/** The Decisioning tool: tabs, sheets and toast for one account. Owns its own scroll area. */
export const DecisioningPanel = ({
	accountId,
	initialTab,
	initialSheet,
	initialExpandedIds,
}: DecisioningPanelProps) => (
	<DecisioningDataProvider accountId={accountId}>
		<DecisioningPanelProvider
			accountId={accountId}
			initialTab={initialTab}
			initialSheet={initialSheet}
			initialExpandedIds={initialExpandedIds}
		>
			<DecisioningPanelBody />
		</DecisioningPanelProvider>
	</DecisioningDataProvider>
);
